<script>
	import thumb_bFJ7NBzZsqI from '$lib/Components/Youtube/images/bFJ7NBzZsqI.jpg?w=610';

	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import OurLocation from '$lib/PageSections/OurLocation/OurLocation.svelte';

	import ahc from './images/affiliate-logo-AHC-2.png';
	import cs from './images/affiliate-logo-CS-6.png';
	import hpg from './images/affiliate-logo-HPG-5.png';
	import oec from './images/affiliate-logo-OEC-4.png';
	import ro from './images/affiliate-logo-RO-7.png';
	import handshake from './images/DEI_icon-01-cropped.svg';
	import rulerPen from './images/DEI_icon-02-cropped.svg';
	import magnifyingGlass from './images/DEI_icon-03-cropped.svg';
	import headGears from './images/DEI_icon-04-cropped.svg';
	import hh from './images/hire-heros-usa-logo-grey.png';
	import indowFactory from './images/indow.png?w=1200;1000;800;600;400;';
	import pm from './images/preservation-maryland.png';
</script>

<!-- eslint-disable better-tailwindcss/no-unknown-classes -->

<Section backgroundColor="white">
	<ul class="bullet-circle grid">
		<li>
			<a href="/about-indow/media">Media Coverage</a>
		</li>
		<li>
			<a href="/about-indow/management-team">The Team</a>
		</li>
		<li>
			<a href="/about-indow/careers">Indow Careers</a>
		</li>
		<li>
			<a href="/about-indow/contractor-discount-program"
				>Contractor Discount Program</a
			>
		</li>
		<li>
			<a href="/about-indow/contact">Contact Indow</a>
		</li>
	</ul>

	<Youtube posterImageSrc={thumb_bFJ7NBzZsqI} videoId="bFJ7NBzZsqI" />
	<h2>Our Sustainable Mission and Vision</h2>
	<p>
		<strong>Our mission</strong> is to provide you with comfort, quiet and savings
		while helping preserve the environment and historic buildings.
	</p>
	<p>
		Indow was launched in November 2010, delivering an easy-to-use window
		insulation solution in an elegant form. Our window inserts are now available
		across the U.S. and Canada and we are growing! Our dynamic team is dedicated
		to building and refining our product, custom making each insert to fit
		drafty or under-performing windows.
	</p>
	<p>
		<strong>Our vision</strong> is that as we become more efficient, we will
		share the increased profit margin with our workers through higher wages,
		with the company through reinvested earnings to fuel continued growth, and
		with our customers through lower prices that will make the product easier to
		purchase and therefore block more climate-changing CO2 emissions. We will
		reach this vision if we harness the creativity and discipline of each team
		member and if our customers support our continued growth.
		<a href="/how-to/get-indow-inserts">Please join us!</a>
	</p>
	<p>
		<a href="/resources/customer-reviews" class="font-bold">
			Read what our customers had to say!
		</a>
	</p>
</Section>
<Section backgroundColor="white">
	<hr />
</Section>

<Section backgroundColor="white" class="affiliations">
	<h2>Affiliations</h2>
	<ul class="flex list-none flex-row flex-wrap justify-around">
		<li>
			<a href="https://www.hireheroesusa.org" target="_blank" rel="noreferrer">
				<Image src={hh} alt="Hire Heroes USA logo." class="w-44" />
			</a>
		</li>
		<li>
			<a href="https://oeconline.org" target="_blank" rel="noreferrer">
				<Image
					src={oec}
					alt="Indow window oregon environmental council."
					class="w-44"
				/>
			</a>
		</li>
		<li>
			<a
				href="https://www.climatesolutions.org"
				target="_blank"
				rel="noreferrer"
			>
				<Image src={cs} alt="Indow window climate solutions." class="w-44" />
			</a>
		</li>
		<li>
			<a href="https://visitahc.org" target="_blank" rel="noreferrer">
				<Image
					src={ahc}
					alt="Indow window architecture heritage center"
					class="w-44"
				/>
			</a>
		</li>
		<li>
			<a href="https://hpguild.org/about-us/" target="_blank" rel="noreferrer">
				<Image
					src={hpg}
					alt="Indow window home performance guild of Oregon."
					class="w-44"
				/>
			</a>
		</li>
		<li>
			<a
				href="https://www.preservationmaryland.org"
				target="_blank"
				rel="noreferrer"
			>
				<Image
					src={pm}
					alt="Indow window Preservation Maryland."
					class="w-44"
				/>
			</a>
		</li>
		<li>
			<a href="https://www.restoreoregon.org" target="_blank" rel="noreferrer">
				<Image src={ro} alt="Indow window restore Oregon." class="w-44" />
			</a>
		</li>
	</ul>
</Section>

<Section backgroundColor="blue">
	<h2>Diversity, Equity, and Inclusion at Indow</h2>
	<p>
		Indow is committed to being a diverse, equitable, and inclusive workplace.
		To us, that means a place where all team members feel valued and respected
		and their voice is heard. To enact this, we are committed to internal
		surveys, training, equitable hiring practices, and a DEI committee that
		supports the following:
	</p>
	<Grid vertical gap={0}>
		<div class="diversity-box">
			<div class="dei-icon">
				<div>
					<Image src={handshake} alt="Handshake" class="max-h-20" />
				</div>
				<p>Mutual Respect</p>
			</div>
			<p>
				Within the parameters of our core values, we are committed to diversity,
				equity, and inclusion; and we fundamentally value and respect
				experiences that are different from our own.
			</p>
		</div>

		<div class="diversity-box">
			<div class="dei-icon">
				<div>
					<Image src={rulerPen} alt="Ruler and pen" class="max-h-20" />
				</div>
				<p>Knowledge & Creativity</p>
			</div>
			<p>
				By increasing diversity, equity, and inclusion, we believe we will
				access more expansive and varied ideas, information, and perspectives,
				making us more creative and improving our decision-making power.
			</p>
		</div>

		<div class="diversity-box">
			<div class="dei-icon">
				<div>
					<Image
						src={magnifyingGlass}
						alt="Magnifying glass"
						class="max-h-20"
					/>
				</div>
				<p>Transparency</p>
			</div>
			<p>
				We believe we have a responsibility to society and our sector to achieve
				our goals with honesty and transparency, regularly reporting progress
				and lessons learned along the way.
			</p>
		</div>

		<div class="diversity-box">
			<div class="dei-icon">
				<div>
					<Image src={headGears} alt="Head full of gears" class="max-h-20" />
				</div>
				<p>Strategic Approach</p>
			</div>
			<p>
				To achieve our aims, we believe it is necessary to be strategic and
				intentional in formalizing and pursuing meaningful diversity goals.
			</p>
		</div>
	</Grid>
</Section>

<GetAFreeEstimate backgroundColor="grey" />

<Parallax image={indowFactory} />
<OurLocation />

<style>
	ul.bullet-circle {
		list-style-type: none;
		width: 100%;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(10ch, auto));
		gap: 2rem;
		padding: 0.5rem;
	}

	.bullet-circle li {
		display: grid;
	}

	.bullet-circle li a {
		column-gap: 0.5rem;
		display: grid;
		grid-template-columns: auto 1fr;
		align-items: center;
		color: var(--color-indow-grey-dark);
		font-weight: bold;
		font-size: 1rem;
	}

	.bullet-circle li a:before {
		content: '';
		height: 1.15rem;
		width: 1.15rem;
		background-color: var(--color-indow-blue);
		border-radius: 50%;
	}

	.bullet-circle li a:hover:before {
		background-color: var(--color-indow-grey);
	}

	.diversity-box {
		display: grid;
		column-gap: 2rem;
		grid-auto-flow: column;
		align-items: center;
		border-bottom: solid 0.15rem var(--pure-white);
		padding-block-start: 2rem;
		padding-block-end: 2rem;
	}

	@media screen and (max-width: 48rem) {
		.diversity-box {
			grid-auto-flow: row;
			justify-items: center;
			row-gap: 1rem;
		}
	}

	.diversity-box p {
		text-align: left;
	}

	@media screen and (max-width: 48rem) {
		.diversity-box p {
			text-align: center;
		}
	}

	.diversity-box .dei-icon {
		width: 14ch;
		display: grid;
		gap: 0.5rem;
		margin: 0 1rem;
		justify-items: center;
		justify-content: center;
		color: var(--color-indow-grey-dark);
		font-weight: bold;
	}

	.diversity-box .dei-icon p {
		color: var(--color-indow-grey-dark);
		text-align: center;
		line-height: 1;
		word-break: normal;
	}

	.diversity-box .dei-icon div {
		width: 4rem;
	}

	.diversity-box:first-of-type {
		padding-block-start: 0;
	}
</style>
